// extracted by mini-css-extract-plugin
module.exports = {"fallback":"Fallback_fallback__2UsOg"};